/* Mattress Crafters add-on ladder and discount sync (2026-10-07, Lewis).
   A builder mattress is always at its normal price. The pieces that go with it come off on one ladder,
   counted by add-on types in the cart (base, bedhead, pillow, protector, quilt):
     1 type 10 percent, 2 to 4 types 15 percent, all 5 types 20 percent (the customer total).
   WELCOME5 (5 percent off the order, auto applied once per session) stays exactly as before and each
   BEDROOM code tops it up on the add-on lines, so WELCOME5 plus the code lands the add-ons on the rung.
   A buy X get Y code only applies when the cart holds its full get quantity, so there is one code per
   add-on unit count and the cart picks the code for its units (above the top code, the top code).
   Source of truth: bundle-builder-2026-09/addons-only-2026-10-07/ladder-phase2.json.

   This file is the one discount sync for both managed families (the CART10 to CART50 spend rung and the
   BEDROOM ladder rung), shared by the theme cart drawer (sections/cart-drawer.liquid) and the Boutique
   mini cart #mcqc (sections/mc-boutique-vsl.liquid), plus the one call bundle add used by the drawer
   cards and the product page cards. Rules:
     - WELCOME5 is managed: never dropped to make room for a ladder code.
     - The ladder code is added whenever no other customer code is applied: a customer code wins. If the
       shopper removed WELCOME5 by hand the ladder code stays on its own (the top up only, still a saving).
     - Every write is checked: a code Shopify returns as applicable false, or a customer code our write
       knocked off, is taken out again and remembered for that cart for the session, so no update.js loop
       can start. */
(function (root) {
  'use strict';
  if (root.MCAddonLadder) return;

  var MATTRESSES = ['boutique-mattress-memory-foam', 'boutique-deluxe-mattress', 'luxury-mattress-australia-boutique', 'boutique-extra-firm-mattress', 'boutique-craft-cell-mattress', 'hybrid-mattress-australia', 'retreat', 'resort', 'grandeur', 'superior', 'elevate-essential-mattress', '4-play-mattress', 'chiro-luxe', 'exquisite-premier-mattress', 'exquisite-signature-mattress'];
  var TYPES = {
    base: ['upholstered_portabase_bed_base', 'upholstered-portabase-grey-bed-base', 'activ8-bed-base'],
    bedhead: ['shay-bedhead', 'leo-bedhead', 'iris-bedhead', 'tyler-bedhead', 'coco-bedhead'],
    pillow: ['natural-latex-pillow', 'soy-oil-memory-foam-pillow', 'ardor-low-profile-memory-foam', 'ardor-balance-medium-2-0-memory-foam-pillow', 'ardor-balance-high-3-0-memory-foam-pillow', 'ardor-glacier-performance-cooling-adjustable-pillow', 'ardor-australias-softest-1100gm-plush-fibre-pillow'],
    protector: ['bamboo-mattress-protector'],
    quilt: ['quilt-wool-350g', 'quilt-wool-500g', 'quilt-polyster-300g', 'ardor-doona-medium-weight-300gm']
  };
  /* pct is what the customer saves on the add-ons in total (WELCOME5 included); topUp is what the code itself
     takes, which is all a shopper gets once WELCOME5 is off the cart (ladder-phase2.json, 7 Oct) */
  var LADDER = [
    { types: 1, pct: 10, topUp: 0.0526, codes: { 1: 'BEDROOM10', 2: 'BEDROOM10-2', 3: 'BEDROOM10-3', 4: 'BEDROOM10-4' } },
    { types: 2, pct: 15, topUp: 0.1053, codes: { 2: 'BEDROOM15', 3: 'BEDROOM15-3', 4: 'BEDROOM15-4', 5: 'BEDROOM15-5', 6: 'BEDROOM15-6', 7: 'BEDROOM15-7', 8: 'BEDROOM15-8' } },
    { types: 5, pct: 20, topUp: 0.1579, codes: { 5: 'BEDROOM20-5', 6: 'BEDROOM20', 7: 'BEDROOM20-7', 8: 'BEDROOM20-8' } }
  ];
  var SPEND_RE = /^CART(10|20|30|40|50|100)$/;
  var LADDER_RE = /^BEDROOM(10|15|20)(-\d+)?$/;
  var W5 = 'WELCOME5';
  var W5_KEY = 'mc_welcome5_auto_attempted'; /* shared with the drawer's WELCOME5 auto apply */
  var REFUSED_KEY = 'mc_addon_refused';
  var TIER_SIZE = 100000; /* $1,000 in cents, one spend rung */
  var SIZE_OPTIONS = ['size', 'bedding size', 'sizes'];
  var SIZE_NAMES = ['Single', 'Long Single', 'King Single', 'Double', 'Queen', 'King', 'Super King'];

  var TYPE_OF = {};
  Object.keys(TYPES).forEach(function (t) { TYPES[t].forEach(function (h) { TYPE_OF[h] = t; }); });
  var IS_MATTRESS = {};
  MATTRESSES.forEach(function (h) { IS_MATTRESS[h] = true; });

  function up(c) { return String(c == null ? '' : c).toUpperCase(); }
  function isSpend(c) { return SPEND_RE.test(up(c)); }
  function isLadder(c) { return LADDER_RE.test(up(c)); }
  function isW5(c) { return up(c) === W5; }
  function isManaged(c) { return isSpend(c) || isLadder(c) || isW5(c); }
  function items(cart) { return (cart && Array.isArray(cart.items)) ? cart.items : []; }
  function unitPrice(it) { return it.original_price != null ? it.original_price : it.price; }

  function rungFor(typeCount) {
    var hit = null;
    LADDER.forEach(function (r) { if (typeCount >= r.types) hit = r; });
    return hit;
  }
  function pctFor(typeCount) { var r = rungFor(typeCount); return r ? r.pct : 0; }
  function codeFor(rung, units) {
    var keys = Object.keys(rung.codes).map(Number).sort(function (a, b) { return a - b; });
    if (!keys.length || units < keys[0]) return null;
    var top = keys[keys.length - 1];
    var k = units > top ? top : units;
    return rung.codes[k] ? { code: rung.codes[k], units: k } : null;
  }

  function sizeOf(it) {
    var o = (it.options_with_values || []).filter(function (x) { return x && SIZE_OPTIONS.indexOf(String(x.name).toLowerCase()) > -1; })[0];
    if (o) return o.value;
    var v = (it.variant_options || String(it.variant_title || '').split(' / ')).filter(function (x) { return SIZE_NAMES.indexOf(x) > -1; })[0];
    return v || null;
  }

  /* What the cart is worth on the ladder. null when there is no builder mattress or no add-on. */
  function ladderState(cart) {
    var list = items(cart), mattresses = 0, size = null, seen = {}, types = [], units = 0, lines = [];
    list.forEach(function (it) {
      if (IS_MATTRESS[it.handle] && it.quantity > 0) { mattresses += it.quantity; if (!size) size = sizeOf(it); }
      var t = TYPE_OF[it.handle];
      if (t && it.quantity > 0) {
        if (!seen[t]) { seen[t] = 1; types.push(t); }
        units += it.quantity;
        lines.push(it);
      }
    });
    if (!mattresses) return null;
    var base = { mattresses: mattresses, size: size, types: types, units: units, rung: null, pct: 0, code: null, codeUnits: 0, coveredUnits: 0, savingCents: 0 };
    if (!types.length) return base;
    var rung = rungFor(types.length);
    var c = rung && codeFor(rung, units);
    if (!c) return base;
    /* Shopify discounts the get quantity; when the cart holds more units than the code, assume the
       cheapest units are the discounted ones (a floor, never an overstatement) */
    var prices = [];
    lines.forEach(function (it) { for (var i = 0; i < it.quantity; i++) prices.push(unitPrice(it)); });
    prices.sort(function (a, b) { return a - b; });
    var covered = prices.slice(0, c.units).reduce(function (a, p) { return a + p; }, 0);
    base.rung = rung.types; base.pct = rung.pct; base.code = c.code; base.codeUnits = c.units;
    base.coveredUnits = Math.min(units, c.units);
    base.savingCents = Math.round(covered * rung.pct / 100);
    return base;
  }

  function ladderCodeFor(cart) { var s = ladderState(cart); return s ? s.code : null; }

  function spendCodeFor(cart) {
    var total = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    var tier = Math.min(5, Math.floor((total || 0) / TIER_SIZE));
    return tier > 0 ? 'CART' + tier * 10 : null;
  }

  /* ---------- session memory of codes Shopify refused for a given cart ---------- */
  function store() { try { return root.sessionStorage || null; } catch (e) { return null; } }
  function sGet(k) { try { var s = store(); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function sSet(k, v) { try { var s = store(); if (s) s.setItem(k, v); } catch (e) {} }
  function signature(cart) {
    var lines = items(cart).filter(function (it) { return it.quantity > 0; }).map(function (it) { return it.variant_id + ':' + it.quantity; }).sort();
    var customer = codesOf(cart, true).filter(function (c) { return !isManaged(c); }).map(up).sort();
    return lines.join(',') + '|' + customer.join(',');
  }
  function refusedList() { try { return JSON.parse(sGet(REFUSED_KEY) || '[]'); } catch (e) { return []; } }
  function isRefused(sig, code) { return !!code && refusedList().indexOf(sig + '#' + up(code)) > -1; }
  function remember(sig, codes) {
    var l = refusedList();
    codes.forEach(function (c) { var k = sig + '#' + up(c); if (l.indexOf(k) < 0) l.push(k); });
    sSet(REFUSED_KEY, JSON.stringify(l.slice(-40)));
  }

  function codesOf(cart, applicableOnly) {
    return ((cart && cart.discount_codes) || []).filter(function (d) { return d && d.code && (!applicableOnly || d.applicable); }).map(function (d) { return String(d.code); });
  }

  /* The pure decision. ctx: { w5Due: WELCOME5 may join this write, refused: function (sig, code) } */
  function plan(cart, ctx) {
    ctx = ctx || {};
    var refused = ctx.refused || isRefused;
    var applicable = codesOf(cart, true);
    var keep = applicable.filter(function (c) { return !isSpend(c) && !isLadder(c); }); /* customer codes and WELCOME5, as today */
    var customer = keep.filter(function (c) { return !isW5(c); });
    var w5On = keep.some(isW5);
    var sig = signature(cart);
    var count = cart.item_count != null ? cart.item_count : items(cart).reduce(function (a, it) { return a + it.quantity; }, 0);
    var addW5 = !!ctx.w5Due && count > 0 && !w5On && customer.length === 0 && !refused(sig, W5);
    var spend = spendCodeFor(cart);
    if (spend && refused(sig, spend)) spend = null;
    var ladder = customer.length === 0 ? ladderCodeFor(cart) : null; /* with or without WELCOME5 (orchestrator, 7 Oct) */
    if (ladder && refused(sig, ladder)) ladder = null;
    var target = keep.slice();
    if (addW5) target.push(W5);
    if (spend) target.push(spend);
    if (ladder) target.push(ladder);
    var cur = applicable.map(up).sort().join(',');
    var want = target.map(up).sort().join(',');
    /* a managed rung left on the cart as applicable false is cleaned up too */
    var stale = codesOf(cart, false).some(function (c) {
      return (isSpend(c) || isLadder(c)) && applicable.map(up).indexOf(up(c)) < 0 && target.map(up).indexOf(up(c)) < 0;
    });
    var added = target.filter(function (c) { return applicable.map(up).indexOf(up(c)) < 0; });
    return { target: target, write: cur !== want || stale, added: added, keep: keep, sig: sig, spend: spend, ladder: ladder, addW5: addW5, customer: customer };
  }

  /* After a write: which of the codes we just added did Shopify refuse, and did we knock off a code that
     was already applied (a customer code, or WELCOME5) */
  function verify(before, p, after) {
    var ok = codesOf(after, true).map(up);
    var refusedNow = p.added.filter(function (c) { return ok.indexOf(up(c)) < 0; });
    var lost = p.keep.filter(function (c) { return ok.indexOf(up(c)) < 0; });
    if (lost.length) refusedNow = p.added.slice(); /* what was already applied wins over anything we added */
    var seen = {};
    refusedNow = refusedNow.filter(function (c) { var k = up(c); if (seen[k]) return false; seen[k] = 1; return true; });
    if (!refusedNow.length) return { refused: [], rewrite: null };
    var drop = refusedNow.map(up);
    return { refused: refusedNow, rewrite: p.target.filter(function (c) { return drop.indexOf(up(c)) < 0; }) };
  }

  /* ---------- network ---------- */
  function routeRoot() { try { return (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  function fetchCart() { return root.fetch(routeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  /* update.js nests each cart level discount under discount_application; /cart.js does not */
  function normalize(c) {
    if (c && Array.isArray(c.cart_level_discount_applications)) c.cart_level_discount_applications = c.cart_level_discount_applications.map(function (d) { var x = d && d.discount_application ? d.discount_application : d; var o = {}; for (var k in x) o[k] = x[k]; return o; });
    return c;
  }
  function wellFormed(c) { return c && Array.isArray(c.items) && Array.isArray(c.discount_codes) && (c.cart_level_discount_applications || []).every(function (d) { return d && (d.title || d.key); }); }
  function writeCodes(codes) {
    return root.fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); })
      .then(function (c) { c = normalize(c); return wellFormed(c) ? c : fetchCart(); });
  }
  function enqueue(task) {
    if (!root.__mcEnqueueDiscountSync) {
      root.__mcDiscountSyncQueue = Promise.resolve();
      root.__mcEnqueueDiscountSync = function (t) {
        var next = root.__mcDiscountSyncQueue.then(t, t);
        root.__mcDiscountSyncQueue = next.catch(function () {});
        return next;
      };
    }
    return root.__mcEnqueueDiscountSync(task);
  }

  /* Keeps both managed families right for the cart. Resolves to the cart to render.
     opts.w5: WELCOME5 may be added in this write when the session has not attempted it yet
              (the theme drawer passes true only after an add to cart, the mini cart on every sync, as before)
     opts.refreshEvent: dispatch cart:refresh after a write (the theme drawer re-renders from it) */
  function sync(cart, opts) {
    opts = opts || {};
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    var w5Seen; try { w5Seen = root.sessionStorage.getItem(W5_KEY); } catch (e) { w5Seen = 'blocked'; } /* storage blocked: behave as before */
    var w5Due = !!opts.w5 && !w5Seen && (cart.item_count || 0) > 0;
    var first = plan(cart, { w5Due: w5Due });
    if (!first.write && !w5Due) return Promise.resolve(cart); /* already right, no network */
    if (w5Due) sSet(W5_KEY, '1');
    return enqueue(function () {
      return fetchCart().then(function (fresh) {
        var p = plan(fresh, { w5Due: w5Due });
        if (!p.write) return fresh;
        return writeCodes(p.target).then(function (after) {
          var v = verify(fresh, p, after);
          if (!v.refused.length) return after;
          remember(p.sig, v.refused);
          return writeCodes(v.rewrite);
        }).then(function (done) {
          if (opts.refreshEvent && root.document) root.document.dispatchEvent(new root.CustomEvent('cart:refresh', { bubbles: true }));
          return done;
        });
      }).catch(function () { return fetchCart().catch(function () { return cart; }); });
    });
  }

  /* ---------- one call bundle add ---------- */
  function cartFromSection(html) {
    if (!html) return null;
    var m = String(html).match(/<script type="application\/json" data-mc-cart>([\s\S]*?)<\/script>/);
    if (!m) return null;
    try {
      var s = JSON.parse(m[1]);
      if (!s || !s.cart || !Array.isArray(s.cart.items)) return null;
      var seen = {};
      s.cart.discount_codes = (s.codes || []).filter(function (c) { if (seen[c]) return false; seen[c] = 1; return true; }).map(function (c) { return { code: c, applicable: true }; });
      return { cart: s.cart, compare: s.compare || {} };
    } catch (e) { return null; }
  }

  /* items: [{id, quantity, properties?, selling_plan?}]
     opts.themeDrawer: ask for the theme drawer's own section (the theme's cart:prepare-bundled-sections) plus
       mc-cart-json, then fire variant:add and cart:change the way theme product forms do
     opts.sections: sections to ask for otherwise (the mini cart passes 'mc-cart-json') */
  /* Adds run one after another, so two cards tapped in quick succession never race two cart/add.js calls and
     the panel always redraws from a response that already holds every earlier add (QA 7 Oct). */
  var addChain = Promise.resolve();
  function addBundle(list, opts) {
    var run = addChain.then(function () { return addBundleNow(list, opts); });
    addChain = run.catch(function () {});
    return run;
  }
  function addBundleNow(list, opts) {
    opts = opts || {};
    var doc = root.document;
    var sections = opts.sections ? [].concat(opts.sections) : [];
    if (opts.themeDrawer && doc) {
      var asked = [];
      doc.documentElement.dispatchEvent(new root.CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: asked } }));
      sections = asked.concat(sections);
    }
    if (sections.indexOf('mc-cart-json') < 0) sections.push('mc-cart-json');
    var body = { items: list, sections: sections.slice(0, 5).join(',') };
    return root.fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error((j && (j.description || j.message)) || ('add failed ' + r.status)); e.status = r.status; throw e; }
        return j;
      });
    }).then(function (res) {
      var st = cartFromSection(res.sections && res.sections['mc-cart-json']);
      return (st ? Promise.resolve(st.cart) : fetchCart()).then(function (cart) {
        var tv = root.themeVariables && root.themeVariables.settings;
        if (opts.themeDrawer && tv && (tv.cartType === 'page' || tv.pageType === 'cart')) { root.location.href = routeRoot() + 'cart'; } /* as theme product forms do */
        else if (opts.themeDrawer && doc) {
          cart.sections = res.sections;
          (opts.source || doc.documentElement).dispatchEvent(new root.CustomEvent('variant:add', { bubbles: true, detail: { items: res.items || [], cart: cart } }));
          doc.documentElement.dispatchEvent(new root.CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        }
        return { response: res, cart: cart, compare: st ? st.compare : {}, html: res.sections && res.sections['mc-cart-json'] };
      });
    });
  }

  /* ---------- product page bundle add ----------
     One call (mattress plus pieces) only for a mattress variant that sells normally. Anything else (pre-order,
     backorder, sold out with continue selling, a selling plan, or any pre-order app field or line property on
     a buy box form) takes the proven two step path: the pieces in one cart/add.js, then the page's own form is
     submitted so the pre-order app and the theme add the mattress exactly as they do today.
     stock: { variantId: 1 } for variants that sell normally (snippets/mc-complete-the-bed, from Liquid). */
  var PLAIN_FIELDS = ['id', 'quantity', 'form_type', 'utf8'];
  function pdpPath(fields, stock, preorderMarkup) {
    var id = null, odd = false;
    (fields || []).forEach(function (f) {
      var k = String(f[0]), v = String(f[1] == null ? '' : f[1]);
      if (k === 'id') id = v;
      else if (PLAIN_FIELDS.indexOf(k) < 0) odd = true; /* properties[...], selling_plan, an app's own field */
      if (/pre-?order/i.test(v) || /pre-?order/i.test(k)) odd = true;
    });
    if (!id || odd || preorderMarkup) return 'two';
    return stock && stock[String(id)] === 1 ? 'one' : 'two';
  }
  function mattressFromFields(fields) {
    var item = { id: 0, quantity: 1 };
    fields.forEach(function (f) {
      if (f[0] === 'id') item.id = Number(f[1]);
      if (f[0] === 'quantity') item.quantity = Math.max(1, parseInt(f[1], 10) || 1);
    });
    return item;
  }
  /* opts: { fields: [[name, value]] of the buy box form, pieces: [{id, quantity}], stock, preorderMarkup,
     submit: fn that submits the page's own form, mini: { fastRefresh, openDrawer } } */
  function pdpAdd(opts) {
    var path = pdpPath(opts.fields, opts.stock, opts.preorderMarkup);
    if (path === 'one') {
      return addBundle([mattressFromFields(opts.fields)].concat(opts.pieces), { sections: 'mc-cart-json' }).then(function (res) {
        var M = opts.mini;
        if (!M) { if (root.top && root.top.location) root.top.location.href = '/cart'; return { path: path }; }
        return Promise.resolve(M.fastRefresh(res.html)).then(function () { M.openDrawer(); return { path: path }; });
      });
    }
    return addBundle(opts.pieces, { sections: 'mc-cart-json' }).then(function () {
      opts.submit();
      return { path: path };
    });
  }

  /* ---------- cards built in JS (#mcqc and the product page) from snippets/mc-addon-bundles-data ---------- */
  function money(c) {
    c = Math.round(c);
    return '$' + (c % 100 === 0 ? (c / 100).toLocaleString('en-AU') : (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Cart context for the cards: the size of the first builder mattress, the add-on types already in
     the cart, and how many of each variant the cart holds. */
  function cartContext(cart) {
    var ctx = { size: null, types: {}, qty: {} };
    items(cart).forEach(function (it) {
      if (IS_MATTRESS[it.handle] && !ctx.size) ctx.size = sizeOf(it);
      var t = TYPE_OF[it.handle];
      if (t && it.quantity > 0) ctx.types[t] = 1;
      ctx.qty[String(it.variant_id)] = (ctx.qty[String(it.variant_id)] || 0) + it.quantity;
    });
    return ctx;
  }

  /* What a card may claim for this cart, so no card claims more than the shopper gets:
       'full'  WELCOME5 is applied (and on the product page, where WELCOME5 joins every new cart): the full rung
       'topup' no WELCOME5 and no customer code: only the code's own top up (5, 10 or 15 shown, rounded down)
       'none'  a customer code is applied, which beats the ladder: no percent and no saving at all */
  function offerMode(cart) {
    if (!cart) return 'full';
    var on = codesOf(cart, true);
    if (on.some(function (c) { return !isManaged(c); })) return 'none';
    return on.some(isW5) ? 'full' : 'topup';
  }
  /* basis points the card's saving is worked out at, and the whole percent it shows */
  function offerRate(typeCount, mode) {
    var r = rungFor(typeCount);
    if (!r || mode === 'none') return { bp: 0, shown: 0 };
    if (mode === 'topup') return { bp: Math.round(r.topUp * 10000), shown: Math.floor(r.topUp * 100) };
    return { bp: r.pct * 100, shown: r.pct };
  }

  /* Every card for one mattress size, with its state for the cart (null cart on the product page).
     A card whose pieces are all in the cart is added; a card that shares a type with the cart but is not
     all there is left out so one tap never doubles a piece; the percentage is the rung the cart lands on. */
  function cardsFor(data, size, cart) {
    var S = data && data.sizes && data.sizes[size];
    if (!S) return { bundles: [], singles: [] };
    var ctx = cart ? cartContext(cart) : { types: {}, qty: {} };
    var cartTypes = Object.keys(ctx.types);
    var mode = offerMode(cart);
    var bundles = [];
    (data.bundles || []).forEach(function (b) {
      var pieces = b.pieces.map(function (k) { return S.pieces[k] ? { key: k, v: S.pieces[k] } : null; });
      if (pieces.some(function (p) { return !p || !p.v.available; })) return;
      var added = pieces.every(function (p) { return (ctx.qty[String(p.v.id)] || 0) >= p.v.qty; });
      var overlap = b.pieces.some(function (k) { return ctx.types[k]; });
      if (!added && overlap) return;
      var types = {}; cartTypes.forEach(function (t) { types[t] = 1; }); b.pieces.forEach(function (k) { types[k] = 1; });
      var rate = offerRate(Object.keys(types).length, mode);
      var full = pieces.reduce(function (a, p) { return a + p.v.price * p.v.qty; }, 0);
      var saving = Math.round(full * rate.bp / 10000);
      bundles.push({ kind: 'bundle', key: b.key, name: b.name, img: b.img, srcset: b.srcset, line: S.lines[b.key] || '', mode: mode, pct: rate.shown, full: full, saving: saving, price: full - saving, added: added,
        items: pieces.map(function (p) { return { id: p.v.id, quantity: p.v.qty }; }) });
    });
    var singles = [];
    ['base', 'bedhead', 'pillow', 'protector', 'quilt'].forEach(function (k) {
      var v = S.pieces[k], prod = data.products && data.products[k];
      if (!v || !v.available || !prod || ctx.types[k]) return;
      var types = {}; cartTypes.forEach(function (t) { types[t] = 1; }); types[k] = 1;
      singles.push({ kind: 'single', key: k, name: prod.name, img: prod.img, srcset: prod.srcset, url: prod.url, price: v.price, mode: mode, pct: offerRate(Object.keys(types).length, mode).shown, items: [{ id: v.id, quantity: 1 }] });
    });
    return { bundles: bundles, singles: singles, mode: mode };
  }

  /* Markup shared by #mcqc and the product page. mode 'mini' | 'pdp'; opts.button overrides the button label. */
  function cardHtml(c, mode, opts) {
    opts = opts || {};
    var img = '<img class="mcab-img" src="' + esc(c.img) + '"' + (c.srcset ? ' srcset="' + esc(c.srcset) + '" sizes="' + (mode === 'pdp' ? '180px' : '140px') + '"' : '') + ' alt="" loading="lazy" decoding="async" width="300" height="300">';
    var btn = c.added
      ? '<button type="button" class="mcab-btn" disabled>Added</button>'
      : '<button type="button" class="mcab-btn" data-mcab-add="' + mode + '" data-mcab-items="' + esc(JSON.stringify(c.items)) + '">' + esc(opts.button || (c.kind === 'bundle' ? 'Add bundle' : 'Add')) + '</button>';
    var price = c.kind === 'bundle' && c.saving > 0
      ? '<div class="mcab-price"><b>' + money(c.price) + '</b><s>' + money(c.full) + '</s></div><div class="mcab-save">Save ' + money(c.saving) + ' with your mattress</div>'
      : '<div class="mcab-price"><b>' + money(c.price) + '</b></div>';
    return '<div class="mcab-card' + (c.added ? ' is-added' : '') + '" data-mcab-key="' + esc(c.key) + '">' + img +
      '<div class="mcab-info"><div class="mcab-name">' + esc(c.name) + '</div>' + (c.kind === 'bundle' && c.line ? '<div class="mcab-pieces">' + esc(c.line) + '</div>' : '') +
      price + (c.pct > 0 ? '<div class="mcab-pct">' + c.pct + '% off when bought with a mattress</div>' : '') + btn + '</div></div>';
  }
  var LADDER_LINE = 'With a mattress, add-ons are 10% off for one piece, 15% for two to four and 20% for all five.';
  function rowsHtml(data, cart, mode) {
    var ctx = cartContext(cart);
    if (!ctx.size) return '';
    var c = cardsFor(data, ctx.size, cart);
    var out = '';
    if (c.bundles.length) out += '<div class="mcab-sec"><p class="mcab-h">Bundle your bed</p>' + (c.mode === 'full' ? '<p class="mcab-sub">' + LADDER_LINE + '</p>' : '') + '<div class="mcab-row">' + c.bundles.map(function (x) { return cardHtml(x, mode); }).join('') + '</div></div>';
    if (c.singles.length) out += '<div class="mcab-sec"><p class="mcab-h">Add pieces one at a time</p><div class="mcab-row">' + c.singles.map(function (x) { return cardHtml(x, mode); }).join('') + '</div></div>';
    return out ? '<div class="mcab" data-mcab-rows>' + out + '</div>' : '';
  }

  /* Theme drawer cards are rendered by Liquid; one delegated listener adds them. */
  function onDrawerCardClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mcab-add="drawer"]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var list; try { list = JSON.parse(btn.getAttribute('data-mcab-items')); } catch (err) { return; }
    var label = btn.textContent;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding';
    addBundle(list, { themeDrawer: true, source: btn }).catch(function (err) {
      btn.textContent = err && err.status === 422 ? 'Not available' : label;
      btn.disabled = false; btn.removeAttribute('aria-busy');
      root.document.dispatchEvent(new root.CustomEvent('cart:refresh'));
    });
  }
  if (root.document && root.document.addEventListener) root.document.addEventListener('click', onDrawerCardClick);

  root.MCAddonLadder = {
    MATTRESSES: MATTRESSES, TYPES: TYPES, LADDER: LADDER, TYPE_OF: TYPE_OF, LADDER_LINE: LADDER_LINE,
    isMattress: function (h) { return !!IS_MATTRESS[h]; }, typeOf: function (h) { return TYPE_OF[h] || null; },
    isSpend: isSpend, isLadder: isLadder, isManaged: isManaged,
    label: function (code) { return isSpend(code) ? 'Reward' : isLadder(code) ? 'Bundle saving' : code; },
    rungFor: rungFor, pctFor: pctFor, codeFor: codeFor, ladderState: ladderState, ladderCodeFor: ladderCodeFor, spendCodeFor: spendCodeFor,
    signature: signature, plan: plan, verify: verify, sync: sync, normalize: normalize,
    addBundle: addBundle, cartFromSection: cartFromSection, pdpPath: pdpPath, pdpAdd: pdpAdd,
    cartContext: cartContext, offerMode: offerMode, offerRate: offerRate, cardsFor: cardsFor, cardHtml: cardHtml, rowsHtml: rowsHtml, money: money
  };

  /* calls made by inline scripts before this deferred file ran */
  var pending = root.__mcAddonPending || [];
  root.__mcAddonPending = { push: function (fn) { try { fn(root.MCAddonLadder); } catch (e) {} } };
  pending.forEach(function (fn) { try { fn(root.MCAddonLadder); } catch (e) {} });
})(typeof window !== 'undefined' ? window : globalThis);
